import { Navigate } from 'react-router-dom'

import { firstVisibleStudioModePath } from '@/constants/studio-nav'
import { useTenantFeatures } from '@/hooks'

/** /studio 索引：跳过模式选择页，直达首个可用创作模式 */
export function StudioIndexRedirect() {
  const { features } = useTenantFeatures()
  return <Navigate to={firstVisibleStudioModePath(features)} replace />
}
